/* eslint-disable @typescript-eslint/no-explicit-any */
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/tr';
import { TimePicker } from "@mui/x-date-pickers";
import { TextField } from "@mui/material";
import { ICsmDateTimePickerProps } from "./CsmDateWithTimePicker";

interface ICsmTimePickerProps extends Omit<ICsmDateTimePickerProps, "canClean" | "fullWidth" | "dateLabel" | "timeLabel"> {
    label: string,
}

function CsmTimePicker(props: ICsmTimePickerProps) {
    const { label, value, onChange, error, helperText, style, disabled, errorText } = props;

    const helperTextToUse = (typeof errorText === "string") ? errorText : helperText;
    const errorToUse = (typeof errorText === "string") ? (errorText ?? "").length > 0 : error;

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="tr">
            <div style={style}>
                <TimePicker
                    disabled={disabled}
                    label={label}
                    value={value}
                    onChange={(e) => onChange(new Date(e as any))}
                    renderInput={(params) =>
                        <TextField {...params}
                            error={errorToUse}
                            helperText={helperTextToUse} />}
                />
            </div>
        </LocalizationProvider>
    )
}

export default CsmTimePicker;